import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { VEHICLE_TYPE_OPTIONS, FUEL_TYPE_OPTIONS, COLOR_OPTIONS } from '../../../components/VehicleFormUnified';

const VehicleDetailsForm = ({ formData, onChange, errors }) => {
  const handleInputChange = (field, value) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <div className="p-2 rounded-lg bg-primary/10">
          <svg className="w-5 h-5 md:w-6 md:h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Datos del Vehículo
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        <Select
          label="Tipo de Vehículo"
          required
          options={VEHICLE_TYPE_OPTIONS}
          value={formData?.vehicleType}
          onChange={(value) => handleInputChange('vehicleType', value)}
          error={errors?.vehicleType}
          placeholder="Seleccionar tipo"
        />

        <Input
          label="Placas"
          type="text"
          required
          placeholder="Ej: ABC-123-D"
          value={formData?.plates}
          onChange={(e) => handleInputChange('plates', e?.target?.value?.toUpperCase())}
          error={errors?.plates}
          maxLength={10}
        />

        <Input
          label="Marca"
          type="text"
          required
          placeholder="Ej: Toyota, Honda, BMW"
          value={formData?.brand}
          onChange={(e) => handleInputChange('brand', e?.target?.value)}
          error={errors?.brand}
        />

        <Input
          label="Modelo"
          type="text"
          required
          placeholder="Ej: Corolla, Civic, X5"
          value={formData?.model}
          onChange={(e) => handleInputChange('model', e?.target?.value)}
          error={errors?.model}
        />

        <Input
          label="Año"
          type="number"
          required
          placeholder="Ej: 2024"
          value={formData?.year}
          onChange={(e) => handleInputChange('year', e?.target?.value)}
          error={errors?.year}
          min={1900}
          max={2027}
        />

        <Select
          label="Tipo de Combustible"
          required
          options={FUEL_TYPE_OPTIONS}
          value={formData?.fuelType}
          onChange={(value) => handleInputChange('fuelType', value)}
          error={errors?.fuelType}
          placeholder="Seleccionar combustible"
        />

        <Input
          label="Kilometraje"
          type="number"
          required
          placeholder="Ej: 45000"
          value={formData?.odometer}
          onChange={(e) => handleInputChange('odometer', e?.target?.value)}
          error={errors?.odometer}
          min={0}
          description="Kilómetros recorridos"
        />

        <Select
          label="Color"
          required
          options={COLOR_OPTIONS}
          value={formData?.color}
          onChange={(value) => handleInputChange('color', value)}
          error={errors?.color}
          placeholder="Seleccionar color"
        />

        <Input
          label="Motor"
          type="text"
          placeholder="Ej: 2.0L Turbo, 1.5L"
          value={formData?.engine}
          onChange={(e) => handleInputChange('engine', e?.target?.value)}
          error={errors?.engine}
        />

        <Input
          label="VIN (Número de Serie) — Opcional"
          type="text"
          placeholder="Ej: 1HGBH41JXMN109186"
          value={formData?.vin}
          onChange={(e) => handleInputChange('vin', e?.target?.value?.toUpperCase())}
          error={errors?.vin}
          maxLength={17}
          description="17 caracteres alfanuméricos (opcional)"
        />
      </div>
    </div>
  );
};

export default VehicleDetailsForm;